import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  DialogActions,
  Stack,
  Button,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import FormInput from "../common/FormInput";
import AutoComplete, { AutoCompleteOption } from "../common/AutoComplete";

const EditCarrierModal = (props: any) => {
  const carrierEditData = props.carrierEditData;
  const setCarrierEditData = props.setCarrierEditData;
  const openEditModal = props.openEditModal;
  const setOpenEditModal = props.setOpenEditModal;
  const updateCarrierData = props.updateCarrierData;

  const { t } = useTranslation(["operation"]);

  const submitFunction = (event: any) => {
    event.preventDefault();
    updateCarrierData(carrierEditData);
    setOpenEditModal(false);
  };

  const closeModal = () => {
    setOpenEditModal(false);
  };

  const typeArray: AutoCompleteOption[] = [
    {
      value: true,
      label: t("internOptionSelectName.true"),
    },
    {
      value: false,
      label: t("internOptionSelectName.false"),
    },
  ];

  return (
    <form id="submitForm" onSubmit={(event: any) => submitFunction(event)}>
      <Box sx={{ padding: 20 }}>
        <Dialog
          fullWidth={true}
          PaperProps={{
            sx: {
              maxWidth: "884px !important",
              minHeight: "253px",
              borderRadius: "4px",
            },
          }}
          open={openEditModal}
        >
          <DialogTitle>
            <Grid
              container
              alignItems="center"
              alignContent="center"
              direction="row"
            >
              <Grid xs item className="createEditModal">
                {t("carrier.table.title")}
              </Grid>

              <Grid
                xs
                item
                sx={{ justifyContent: "flex-end", display: "flex" }}
              >
                <CloseIcon
                  color="disabled"
                  fontSize="small"
                  onClick={closeModal}
                />
              </Grid>
            </Grid>
          </DialogTitle>

          <DialogContent>
            <Box>
              <Grid
                container
                alignItems="center"
                alignContent="center"
                mr={0}
                direction="row"
                spacing={2.5}
              >
                <Grid xs item>
                  <TextField
                    fullWidth
                    id="currentStatus"
                    name="currentStatus"
                    onChange={(event: any) => {
                      setCarrierEditData({
                        ...carrierEditData,
                        currentStatus: event.target.value,
                      });
                    }}
                    label={t("carrier.table.currentStatus")}
                    value={carrierEditData?.currentStatus}
                  />
                </Grid>

                <Grid xs item>
                  <AutoComplete
                    fullWidth
                    label={t("carrier.table.active")}
                    value={carrierEditData?.active}
                    options={typeArray}
                    onChange={(event: any) => {
                      setCarrierEditData({
                        ...carrierEditData,
                        active: event,
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>

          <DialogActions style={{ background: "#F8F8F8" }}>
            <Stack direction="row" spacing={2.875} p={1} mr={3.625}>
              <Button variant="outlined" size="medium" onClick={closeModal}>
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 700,
                    lineHeight: 2.25,
                    color: "#C8017D",
                  }}
                  variant="subtitle1"
                >
                  {t("actionButtons.cancel")}
                </Typography>
              </Button>
              <Button
                form="submitForm"
                variant="contained"
                size="medium"
                type={"submit"}
                color="accent"
              >
                <Typography
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 700,
                    lineHeight: 2.25,
                    color: "white",
                  }}
                  variant="subtitle1"
                >
                  {t("actionButtons.save")}
                </Typography>
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Box>
    </form>
  );
};

export default EditCarrierModal;
